import { useState } from "react";
import { Helmet } from "react-helmet";
import "./TicTacToe.css";

export default function TicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [playerTurn, setPlayerTurn] = useState(true);
  const [status, setStatus] = useState("Place your X");
  const [gameOver, setGameOver] = useState(false);
  const [difficulty, setDifficulty] = useState("Easy");
  const [points, setPoints] = useState(100);
  const [bet, setBet] = useState(10);

  const lines = [
    [0,1,2],[3,4,5],[6,7,8],
    [0,3,6],[1,4,7],[2,5,8],
    [0,4,8],[2,4,6]
  ];

  const checkWinner = (squares) => {
    for (let line of lines) {
      const [a,b,c] = line;
      if (squares[a] && squares[a] === squares[b] && squares[b] === squares[c]) {
        return squares[a];
      }
    }
    return squares.includes(null) ? null : "Draw";
  }

  const handleClick = (index) => {
    if (board[index] || gameOver || !playerTurn) return;
    const newBoard = [...board];
    newBoard[index] = "X";
    setBoard(newBoard);
    setPlayerTurn(false);

    const result = checkWinner(newBoard);
    if (result) {
      updateStatus(result);
      return;
    }

    setTimeout(() => aiMove(newBoard), 300);
  }

  const aiMove = (currentBoard) => {
    if (gameOver) return;
    const newBoard = [...currentBoard];
    let move;

    if(difficulty==="Easy"){
      const empty = newBoard.map((v,i)=>v===null?i:null).filter(v=>v!==null);
      move = empty[Math.floor(Math.random()*empty.length)];
    } else if(difficulty==="Hard"){
      move = getHardMove(newBoard);
    } else{
      move = getBestMove(newBoard);
    }

    newBoard[move] = "O";
    setBoard(newBoard);
    setPlayerTurn(true);

    const result = checkWinner(newBoard);
    if(result) updateStatus(result);
  }

  const getHardMove = (squares) => {
    for(let i=0;i<9;i++){
      if(!squares[i]){squares[i]="O"; if(checkWinner(squares)==="O"){squares[i]=null; return i;} squares[i]=null;}
    }
    for(let i=0;i<9;i++){
      if(!squares[i]){squares[i]="X"; if(checkWinner(squares)==="X"){squares[i]=null; return i;} squares[i]=null;}
    }
    const empty = squares.map((v,i)=>v===null?i:null).filter(v=>v!==null);
    return empty[Math.floor(Math.random()*empty.length)];
  }

  const getBestMove = (squares) => {
    let bestScore=-Infinity; let move;
    for(let i=0;i<9;i++){
      if(!squares[i]){
        squares[i]="O";
        let score=minimax(squares,false);
        squares[i]=null;
        if(score>bestScore){bestScore=score; move=i;}
      }
    }
    return move;
  }

  const minimax = (squares,isMaximizing)=>{
    const result=checkWinner(squares);
    if(result==="O") return 1;
    if(result==="X") return -1;
    if(result==="Draw") return 0;

    if(isMaximizing){
      let bestScore=-Infinity;
      for(let i=0;i<9;i++){
        if(!squares[i]){
          squares[i]="O";
          let score=minimax(squares,false);
          squares[i]=null;
          bestScore=Math.max(score,bestScore);
        }
      }
      return bestScore;
    } else {
      let bestScore=Infinity;
      for(let i=0;i<9;i++){
        if(!squares[i]){
          squares[i]="X";
          let score=minimax(squares,true);
          squares[i]=null;
          bestScore=Math.min(score,bestScore);
        }
      }
      return bestScore;
    }
  }

  const updateStatus = (result)=>{
    setGameOver(true);
    if(result==="X"){
      setStatus("🎉 You Win!");
      setPoints(points + bet);
    } else if(result==="O"){
      setStatus("💻 You Lose!");
      setPoints(points - bet);
    } else{
      setStatus("🤝 Draw!");
    }
  }

  const resetGame = ()=>{
    setBoard(Array(9).fill(null));
    setGameOver(false);
    setPlayerTurn(true);
    setStatus("Place your X");
  }

  return (
    <div className="tic-wrapper">
      {/* SEO meta */}
      <Helmet>
        <title>Tic Tac Toe Online - Play Free TicTacToe</title>
        <meta name="description" content="Play Tic Tac Toe online for free. Responsive game with AI difficulty levels. Easy, Hard, or Challenge. Place bets and earn points." />
        <meta name="keywords" content="tic tac toe, online tic tac toe, free tic tac toe, play tic tac toe, AI tic tac toe, responsive tic tac toe" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <h2 className="tic-title">Tic Tac Toe</h2>

      <div className="player-info">
        <p>💎 Points: {points}</p>
        <label>
          Bet per Game: 
          <input type="number" min="1" max={points} value={bet} onChange={e=>setBet(Number(e.target.value))}/>
        </label>
      </div>

      <div className="tic-rules">
        <p>Rules:</p>
        <ul>
          <li>You are <strong>X</strong>, AI is <strong>O</strong></li>
          <li>Get 3 in a row to win.</li>
          <li>Select difficulty before starting:</li>
        </ul>

        <div className="difficulty-select">
          <label>
            <input type="radio" value="Easy" checked={difficulty==="Easy"} onChange={e=>setDifficulty(e.target.value)}/> Easy
          </label>
          <label>
            <input type="radio" value="Hard" checked={difficulty==="Hard"} onChange={e=>setDifficulty(e.target.value)}/> Hard
          </label>
          <label>
            <input type="radio" value="Challenge" checked={difficulty==="Challenge"} onChange={e=>setDifficulty(e.target.value)}/> Challenge
          </label>
        </div>
      </div>

      <p className="tic-status">{status}</p>

      <div className="tic-board">
        {board.map((v,i)=>
          <button key={i} className="tic-cell" onClick={()=>handleClick(i)}>{v}</button>
        )}
      </div>

      <button className="reset-btn" onClick={resetGame}>Reset Game</button>

      {/* AdSense Placeholder */}
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <div style={{
          width: "320px",
          height: "100px",
          backgroundColor: "#ccc",
          display: "inline-block",
          lineHeight: "100px",
          color: "#111"
        }}>
          Ad Space
        </div>
      </div>
    </div>
  )
}
